/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for common body services/utilities.
 */
'use strict';

angular
  .module('services.body', [])
  /**
   * A factory with common body utilities.
   */
  .factory('bodyUtils', function ($rootScope) {
    return {
      /**
       * Utility for setting the body style value
       *
       * @param {object} bodyStyle - An object that specifies the styles properties to be
       * applied to the body element.
       */
      setBodyStyle: function (styleObj) {
        $rootScope.bodyStyle = styleObj;
      }
    };
  });
